export enum ESignUpStep {
  FirstStep = 'first-step',
  SecondStep = 'second-step',
  FinalStep = 'final-step',
}
